
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/budget-2026-summariser",
      function () {
        return require("private-next-pages/budget-2026-summariser/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/budget-2026-summariser"])
      });
    }
  